<auth-page infoRowTarget="signin">
  <form
    (ngSubmit)="register()"
    *ngIf="errors$ | async as errors"
    [formGroup]="form"
    ngNativeValidate
  >
    <div
      class="header text-center mb-3"
      [transValues]="{ siteName: settings.get('branding.site_name') }"
      trans
    >
      {{ route.snapshot.data.message || "Create a New Account" }}
    </div>

    <div class="many-inputs">
      <div class="input-container">
        <label for="email" class="font-18" trans
          >Email <span style="color: red; font-size: 14px">*</span>
        </label>
        <input type="email" formControlName="email" id="email" required />
        <p class="error" *ngIf="errors.email">
          <mat-icon svgIcon="warning"></mat-icon>
          <span>{{ errors.email }}</span>
        </p>
        <p class="error" *ngIf="showEmailError">
          <mat-icon svgIcon="warning"></mat-icon>
          <span>Invalid email format. A valid email address can contain '@' and a well known domain with a good domain authority like 'gmail', 'hotmail', 'yahoo', 'outlook', 'boons'.</span>
        </p>
      </div>

      <div class="input-container">
        <label for="register_password" class="font-18" trans
          >Password <span style="color: red; font-size: 14px">*</span></label
        >
        <input
          type="password"
          formControlName="password"
          id="register_password"
          required
        />
        <p class="error" *ngIf="errors.password">
          <mat-icon svgIcon="warning"></mat-icon>
          <span>{{ errors.password }}</span>
        </p>
      </div>

      <div class="input-container">
        <label for="register_password_confirmation" class="font-18" trans
          >Confirm Password
          <span style="color: red; font-size: 14px">*</span></label
        >
        <input
          type="password"
          formControlName="password_confirmation"
          id="register_password_confirmation"
          required
        />
      </div>

      <div
        class="input-container"
        *ngIf="
          settings.get('envato.enable') &&
          settings.get('envato.require_purchase_code')
        "
      >
        <label for="purchase_code" trans>Envato Purchase Code</label>
        <input
          type="text"
          formControlName="purchase_code"
          id="purchase_code"
          required
        />
        <p class="error" *ngIf="errors.purchase_code">
          <mat-icon svgIcon="warning"></mat-icon>
          <span>{{ errors.purchase_code }}</span>
        </p>
      </div>
    </div>

    <div class="policies">
      <mat-checkbox class="policy-checkbox font-16 text-wrap" color="accent">
        By Clicking this box, you agree to our <br />
        <a href="https://boons.io/terms">Terms and Conditions</a>
        and
        <br />
        <a href="https://boons.io/privacy">Privacy Statement</a>
      </mat-checkbox>
    </div>
    <div class="policies" *ngIf="registerPolicies.length">
      <mat-checkbox
        name="remember-me"
        class="policy-checkbox"
        *ngFor="let policy of registerPolicies"
        [formControlName]="policy.id"
        color="accent"
        required
        trans
      >
        <span trans>I accept the</span>&ngsp;
        <a
          [href]="
            policy.type === 'link'
              ? policy.action
              : settings.getBaseUrl() + policy.action
          "
          *ngIf="policy.action"
          target="_blank"
        >
          <strong>{{ policy.label }}</strong>
        </a>
        <strong *ngIf="!policy.action">{{ policy.label }}</strong>
      </mat-checkbox>
    </div>

    <button
      mat-raised-button
      class="mat-focus-indicator primary-button mat-raised-button mat-button-base mat-warn"
      type="submit"
      [disabled]="loading$ | async"
      trans
    >
      Create Account
    </button>

    <div class="text-center py-5">
      <span trans class="font-16 text-muted">Already have an account?</span
      >&ngsp;
      <a [routerLink]="['/login']" class="font-16" trans>Sign in.</a>
      <br />
      <a [routerLink]="['/']" class="font-16" trans>Homepage</a>
    </div>

    <ng-container *ngIf="!settings.get('registration.disable')">
      <button
        type="button"
        class="no-style alternative-signin-method"
        (click)="socialAuth.loginWith('envato')"
        *ngIf="settings.get('social.envato.enable'); else defaultSocialAuth"
      >
        <mat-icon svgIcon="envato-custom"></mat-icon>
        <span trans>Sign in with Envato instead</span>
      </button>
      <ng-template #defaultSocialAuth>
        <div class="social-icons center">
          <!-- <button
            class="btn btn-lg px-5 py-4 font-18"
            style="border: 1px solid #d9d9d9"
            (click)="socialAuth.loginWith('facebook')"
            *ngIf="settings.get('social.facebook.enable')"
          >
            <img
              [src]="getTextureUrl('facebook.png')"
              width="20px"
              class="d-inline-flex"
              alt=""
              style="padding-bottom: 3px"
            />
            Facebook
          </button> -->
          <!-- <button
            class="btn btn-lg px-5 py-4 font-18 ml-5"
            style="border: 1px solid #d9d9d9"
            (click)="socialAuth.loginWith('google')"
            *ngIf="settings.get('social.google.enable')"
          >
            <img
              [src]="getTextureUrl('google.png')"
              width="20px"
              class="d-inline-flex"
              alt=""
              style="padding-bottom: 3px"
            />
            Google
          </button>
          <button
            class="btn btn-lg px-5 py-4 font-18 ml-5"
            style="border: 1px solid #d9d9d9"
            (click)="socialAuth.loginWith('yahoo')"
            *ngIf="settings.get('social.yahoo.enable')"
          >
            <img
              [src]="getTextureUrl('yahoo.png')"
              width="20px"
              class="d-inline-flex"
              alt=""
              style="padding-bottom: 3px"
            />
            Yahoo
          </button> -->
          <!-- <button
            type="button"
            mat-icon-button
            (click)="socialAuth.loginWith('facebook')"
            *ngIf="settings.get('social.facebook.enable')"
            class="social-icon no-style facebook"
            [matTooltip]="'Login with facebook' | trans"
          >
            <mat-icon svgIcon="facebook"></mat-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            (click)="socialAuth.loginWith('google')"
            *ngIf="settings.get('social.google.enable')"
            class="social-icon no-style google"
            [matTooltip]="'Login with google' | trans"
          >
            <mat-icon svgIcon="google"></mat-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            (click)="socialAuth.loginWith('twitter')"
            *ngIf="settings.get('social.twitter.enable')"
            class="social-icon no-style twitter"
            [matTooltip]="'Login with twitter' | trans"
          >
            <mat-icon svgIcon="twitter"></mat-icon>
          </button> -->
        </div>
      </ng-template>
    </ng-container>
  </form>
</auth-page>
